export const DepositSlipsGetters = {
  DepositSlips: 'DepositSlipsGetters.DepositSlips',
  DepositSlipsPerPage: 'DepositSlipsGetters.DepositSlipsPerPage',
  DepositSlipsOffset: 'DepositSlipsGetters.DepositSlipsOffset',
  DepositSlipsLoading: 'DepositSlipsGetters.DepositSlipsLoading',
  DepositSlipsRecordCount: 'DepositSlipsGetters.DepositSlipsRecordCount'
};

export const DepositSlipsMutations = {
  RetrieveDepositSlips: 'DepositSlipsMutations.RetrieveDepositSlips',
  UpdateDepositSlipsPagination: 'DepositSlipsMutations.UpdateDepositSlipsPagination',
  SetDepositSlipsLoading: 'DepositSlipsMutations.SetDepositSlipsLoading',
  SetDepositSlipsRecordCount: 'DepositSlipsMutations.SetDepositSlipsRecordCount',
  SetDepositSlipDownloadComplete: 'DepositSlipsMutations.SetDepositSlipDownloadComplete'
};

export const DepositSlipsActions = {
  RetrieveDepositSlips: 'DepositSlipsActions.RetrieveDepositSlips',
  RetrieveDepositSlipsRecordCount: 'DepositSlipsActions.RetrieveDepositSlipsRecordCount',
  SetDepositSlipsPagination: 'DepositSlipsActions.SetDepositSlipsPagination',
  DownloadDepositSlip: 'DepositSlipsActions.DownloadDepositSlip'
};
